export default {
    'onboarding': import('@/views/integrations/protokol/invoicing/Onboarding') 
}